/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnDestroy } from '@angular/core';
import { NbAuthService } from '@nebular/auth/services/auth.service';

@Component({
  selector: 'ngx-auth',
  styleUrls: ['./auth.component.scss'],
  template: `
  <nb-layout class="no-padding container">


      <nb-layout-column class="col col-md-4 col-sm-12">

        <router-outlet></router-outlet>
      </nb-layout-column>

      <nb-layout-column class="no-padding col-md-8 col-sm-12" style="overflow: hidden;">
        <img class="no-padding col-md-12 img-fluid" src="../../assets/images/new_login.jpg" alt="" style="width: auto; height: 100vh; object-fit: cover;">
      </nb-layout-column>
    </nb-layout>
  `,
})
export class NgxAuthComponent implements OnDestroy {

  subscription: any;

  authenticated = false;
  token = '';

  // showcase of how to use the onAuthenticationChange method
  constructor(protected auth: NbAuthService) {

    this.subscription = auth.onAuthenticationChange()
      .subscribe((authenticated: boolean) => {
        this.authenticated = authenticated;
      });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
